export default "__VITE_ASSET__wMWu_4iP__"